import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EndPointService } from 'src/app/core/services/end-point.service';
import { Company, CompanySearchModel } from 'src/app/shared/personnel-files/models/Company';
import { CompanyAddress } from 'src/app/shared/personnel-files/models/CompanyAddress';
import { PagingState } from '../../framework/paging/PagingState';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  private _baseUrl = '/api/company/';
  private _getAll = 'getall';
  private _count = 'count';
  private _search = 'search';


  constructor(private _endPointService: EndPointService, private _http: HttpClient) {
    this.registerEndPointService();
  }

  private registerEndPointService(): void {
    this._endPointService.registerEndPoint<Company[]>(
      'company_get',
      `${this._baseUrl}`,
      true
    );
    this._endPointService.registerEndPoint<Company[]>(
      'company_getall',
      `${this._baseUrl}${this._getAll}`,
      true
    );
    this._endPointService.registerEndPoint<number>(
      'company_count',
      `${this._baseUrl}${this._count}`,
      true
    );
    this._endPointService.registerEndPoint<number[]>(
      'company_search',
      `${this._baseUrl}${this._search}`,
      true
    );

    this._endPointService.registerEndPoint<Company[]>(
      'company_withoutmaster',
      `${this._baseUrl}getallcompanieswithoutmaster`,
      true
    );
  }

  public get(fetch: boolean = false): Observable<Company[]> {
    return this._endPointService.call<Company[]>('company_get', {}, fetch);
  }

  public getAll(
    pagingState?: PagingState,
    fetch?: boolean
  ): Observable<Company[]> {
    return this._endPointService.call<Company[]>(
      'company_getall',
      pagingState,
      fetch
    );
  }

  public count(searchString: string, fetch?: boolean): Observable<number> {
    return this._endPointService.call<number>(
      'company_count',
      { searchString },
      fetch
    );
  }

  public searchCompany(toSearchCompany: CompanySearchModel, fetch?: boolean): Observable<number[]> {
    return this._endPointService.call<number[]>(
      'company_search',
      toSearchCompany,
      fetch
    );
  }

  public getAllWithoutMaster(): Observable<Company[]> {
    return this._endPointService.call<Company[]>(
      'company_withoutmaster'
    );
  }

  public getCompanyAddresses(): Observable<CompanyAddress[]> {
    return this._http.post<CompanyAddress[]>("/api/company/address", null);
  }

}
